<template>
  <div class="">
    <Card class="">
      <template #title> Kategoriler</template>
      <template #content>
        <div class="mt-1 mb-2 mr-3">
          <Button icon="pi pi-plus " size="small" label="Yeni" @click="_KategoriModal()" />
        </div>
        <DataTable v-if="DataTable_render" :columns="columns" :data="KategoriListesi" v-on:set-child-data="getDataChild"
          :editbutton="true" />
      </template>
    </Card>

    <Dialog v-model:visible="KategoriModal" header="Kategori" :breakpoints="{ '960px': '75vw', '640px': '100vw' }"
      :style="{ width: '25vw' }" modal>

      <div class="formgrid grid ">
        <div class="field col md:col-12">
          <label for="KategoriAd" class="font-bold block">Kategori Ad</label>
          <InputText id="KategoriAd" type="text" v-model="KategoriAd" :invalid="this.Valid.KategoriAd"
            class="text-base text-color w-full" />
        </div>
        <div class="field col md:col-12">
          <label for="KategoriAciklama" class="font-bold block">Kategori Açıklama</label>
          <Textarea id="KategoriAciklama" v-model="KategoriAciklama" rows="2" cols="30"
            :invalid="this.Valid.KategoriAciklama" class="text-base text-color w-full" />
        </div>
      </div>
      <Divider />
      <div class="flex justify-content-end flex-wrap">
        <Button class="m-1" label="Tamam" icon="pi pi-check" iconPos="right" size="small" severity="success"
          @click="this.handleClick()" autofocus />
        <Button class="m-1" label="Kapat" icon="pi pi-times" iconPos="right" size="small" severity="danger"
          @click="this._KategoriModal()" />
      </div>
    </Dialog>
  </div>
</template>

<script>
import DataTable from "../DataTable/BasicDataTable.vue";
import GlobalServis from "../../../../services/GlobalServis";

export default {
  data() {
    return {
      DataTable_render: true,
      KategoriListesi: [],
      columns: [
        { field: "Ad", header: "Kategori Adı" },
        { field: "Aciklama", header: "Aciklama" },
      ],
      KategoriModal: false,
      KategoriModelDurum: null,

      KategoriAd: "",
      KategoriAciklama: "",
      Kategori_rowid: null,

      //--------------
      // Validation Elements
      Valid: {
        KategoriAd: false,
        KategoriAciklama: false,
      }
    };
  },
  methods: {
    getDataChild(getdata_child) {
      this.ResetForm();
      this.KategoriModal = !this.KategoriModal;
      this.KategoriModelDurum = false;
      this.Kategori_rowid = getdata_child.data.Kategori_rowid;
      let data = {
        Kategori_rowid: getdata_child.data.Kategori_rowid,
      };
      GlobalServis.GlobalServis("POST", "GetKategoriInfo", data).then((res) => {
        if (res.status == 200) {
          this.KategoriAd = res.data[0].KategoriAd;
          this.KategoriAciklama = res.data[0].Aciklama;
          this.KategoriKod = res.data[0].Kategori_rowid;
        } else if (res.status == 400) {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Önemli bir hata meydana geldi",
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Bilinmeyen bir hata meydana geldi",
            life: 3000,
          });
        }
      });
    },
    _KategoriModal() {
      this.KategoriModelDurum = true;
      this.KategoriModal = !this.KategoriModal;
      if (this.KategoriModal === true) {
        this.ResetForm();
      }
    },
    handleClick() {
      if (this._FormCheck()) { return; }

      let data = {
        Kategori_rowid: this.Kategori_rowid,
        KategoriAd: this.KategoriAd,
        KategoriAciklama: this.KategoriAciklama,
      };
      if (this.KategoriModelDurum) {
        // Yeni Kategori
        GlobalServis.GlobalServis("POST", "SetKategori", data).then((res) => {
          if (res.status == 200) {
            this.$toast.add({
              severity: "success",
              summary: "Başarılı",
              detail: "Kategori oluşturulmuştur",
              life: 3000,
            });
            this.Refresh();
            this._KategoriModal();
          } else if (res.response.status === 999) {
            this.$toast.add({
              severity: "warn",
              summary: "Uyarı",
              detail: res.response.data,
              life: 3000,
            });
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Hata",
              detail: "Hata oldu",
              life: 3000,
            });
          }
        }).then(() => {
        });

      } else {
        // Edit Kategori
        GlobalServis.GlobalServis("POST", "SetKategori", data).then((res) => {
          if (res.status == 200) {
            this.$toast.add({
              severity: "success",
              summary: "Başarılı",
              detail: "Kategori düzenlemiştir",
              life: 3000,
            });
            this.Refresh();
            this._KategoriModal();
          } else if (res.response.status === 999) {
            this.$toast.add({
              severity: "warn",
              summary: "Uyarı",
              detail: res.response.data,
              life: 3000,
            });
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Hata",
              detail: "Hata oldu",
              life: 3000,
            });
          }
        }).then(() => {
        });
      }

    },
    Refresh() {
      this.DataTable_render = false;
      this.$nextTick(() => {
        this.InitServis();
        this.DataTable_render = true;
      });
    },
    ResetForm() {
      this.KategoriAd = "";
      this.KategoriAciklama = "";
      this.Kategori_rowid = null;
    },
    InitServis() {
      GlobalServis.GlobalServis("GET", "GetKategoriTablosu", "").then((res) => {
        if (res.status == 200) {
          this.KategoriListesi = res.data;
        } else if (res.status == 400) {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Önemli bir hata meydana geldi",
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Bilinmeyen bir hata meydana geldi",
            life: 3000,
          });
        }
      });
    },
    _FormCheck() {
      let Check = false;
      if (this.KategoriAd === "") {
        this.Valid.KategoriAd = true;
        this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Kategori adı girin", life: 3000, });
        Check = true;
        return Check;
      } else { this.Valid.KategoriAd = false; Check = false; }

      if (this.KategoriAciklama === "") {
        this.Valid.KategoriAciklama = true;
        this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Açıklama girin", life: 3000, });
        Check = true;
        return Check;
      } else { this.Valid.KategoriAciklama = false; Check = false; }

      return Check;
    },
  },
  mounted() {
    this.InitServis();
  },
  components: {
    DataTable,
  },
};
</script>